import React from 'react';
import { Shield, Badge, Globe, Award, Scale, TrendingUp } from 'lucide-react';
import { benefits } from '../data/mock';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const iconMap = {
  Shield: Shield,
  Badge: Badge,
  Globe: Globe,
  Award: Award,
  Scale: Scale,
  TrendingUp: TrendingUp
};

const Benefits = () => {
  const renderBenefitCard = (benefit, index) => {
    const Icon = iconMap[benefit.icon];
    return (
      <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-emerald-200 h-full">
        <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-xl flex items-center justify-center mb-4">
          <Icon className="w-7 h-7 text-white" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
        <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
      </div>
    );
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-emerald-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-xl font-semibold">
            Benefits
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why You Should Register Your Trademark
          </h2>
        </div>

        {/* Desktop Grid - Hidden on mobile/tablet */}
        <div className="hidden lg:grid grid-cols-3 gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => renderBenefitCard(benefit, index))}
        </div>

        {/* Mobile/Tablet Slider - Hidden on desktop */}
        <div className="lg:hidden">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={20}
            pagination={{
              clickable: true,
              bulletClass: 'swiper-pagination-bullet !bg-emerald-600',
              bulletActiveClass: 'swiper-pagination-bullet-active'
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20
              }
            }}
            className="benefits-slider"
          >
            {benefits.map((benefit, index) => (
              <SwiperSlide key={index}>
                {renderBenefitCard(benefit, index)}
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Benefits;